<template>
  <span
    class="comment-count"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      lineHeight: `${height}px`
    }"
  >
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 14
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-count {
  display: inline-block;
  border-radius: 4px 0;
  background: #333;
  color: #FFCA27;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
}

[data-mode="light"] {
  .comment-count {
    background: #FFF0C4;
    color: #664E06;
  }
}
</style>